import classNames from 'classnames';
import React from 'react';
import { Button, IconClose } from '../../components';
import css from './Modal.css';

export default ({
    closeButtonClassName,
    disableClosing,
    lightCloseButton,
    scrolled,
    closeBtnRef,
    handleClose,
    renderCloseButton,
}) => {
    const closeButtonClasses = classNames(
        css.close,
        {
            [css.closeLight]: lightCloseButton,
            [css.scrolled]: scrolled !== 'top' && scrolled !== 'unset',
            [css.closingDisabled]: disableClosing,
        },
        closeButtonClassName
    );

    if (typeof renderCloseButton === 'function') {
        return renderCloseButton({
            rootClassName: closeButtonClasses,
            title: 'Schliessen',
            buttonRef: closeBtnRef,
            disabled: disableClosing,
            onClick: disableClosing ? () => null : handleClose,
        });
    }

    return (
        <Button
            rootClassName={closeButtonClasses}
            title="Schliessen"
            buttonRef={closeBtnRef}
            disabled={disableClosing}
            onClick={disableClosing ? () => null : handleClose}
        >
            {/*             Warning!
             *  handleClose expects "span" and "svg"
             *  to be direct children of the button;
             *
             *  If it is needed to change those elements,
             *  it's also needed to change tagName logic inside handleClose
             */}
            <span className={css.closeText}>Schliessen</span>
            <IconClose rootClassName={css.closeIcon} />
        </Button>
    );
};
